/**
 * Helperهای مرتب‌سازی برای ستون‌های Ant Design Table
 * استفاده: { ..., sorter: byNum("amount") } یا sorter: byStr("full_name")
 */

function get(obj, key) {
  // پشتیبانی از dataIndex تو در تو مثل ["department","name"]
  if (Array.isArray(key)) return key.reduce((o, k) => (o == null ? o : o[k]), obj);
  return obj == null ? undefined : obj[key];
}

export const byNum = (key) => (a, b) => (Number(get(a, key)) || 0) - (Number(get(b, key)) || 0);

export const byStr = (key) => (a, b) =>
  String(get(a, key) ?? "").localeCompare(String(get(b, key) ?? ""), "fa");

export const byDate = (key) => (a, b) => {
  const da = new Date(get(a, key) || 0).getTime() || 0;
  const db = new Date(get(b, key) || 0).getTime() || 0;
  return da - db;
};

// برای فیلدهای زمان HH:MM
export const byTime = (key) => (a, b) => {
  const t = (v) => {
    if (!v) return 0;
    const [h, m] = String(v).split(":");
    return (Number(h) || 0) * 60 + (Number(m) || 0);
  };
  return t(get(a, key)) - t(get(b, key));
};

/** مرتب‌سازیِ کدِ پرسنلی — **عددی** نه الفبایی.
 *
 * با مقایسهٔ رشته‌ای، «۰۰۰۹» بعد از «۰۰۱۰» می‌افتاد و کدهای EMP و عددی هم قاطی
 * می‌شدند و لیست بی‌نظم به‌نظر می‌رسید. اینجا فقط رقم‌ها مقایسه می‌شوند و اگر
 * عددشان برابر بود، خودِ رشته تصمیم می‌گیرد.
 */
export const byCode = (key) => (a, b) => {
  const num = (v) => {
    const d = String(get(v, key) ?? "").replace(/\D/g, "");
    return d ? parseInt(d, 10) : Number.MAX_SAFE_INTEGER;   // بی‌کدها ته لیست
  };
  const diff = num(a) - num(b);
  if (diff) return diff;
  return String(get(a, key) ?? "").localeCompare(String(get(b, key) ?? ""), "fa");
};
